import { connect } from 'react-redux';
import { compose, withPropsOnChange, withHandlers } from 'recompose';
import { pick, get } from 'lodash';
import { FullstoryService } from '../../../modules/infra/observability/fullstory';
import servicesProvider from '../../main/services/hoc/servicesProvider';
import SelectAudience from '../components/SelectAudience';
import {
  setCustomerGroup,
  unsetCustomerGroup,
  toggleCustomerGroup,
  fetchBarberCustomerGroups,
  fetchShopCustomerGroups,
  fetchBrandCustomerGroups,
  setNewCustomerWeeks,
  setServiceCustomerGroupServiceId,
} from '../actions';
import { AUDIENCE_TYPE, CAMPAIGN_TYPE } from '../constants';
import { getNewCustomerWeeks, getSelectedAudienceKeys, getServiceCustomerGroupServiceId } from '../selectors';
import { withActionByRole } from '../../common/helpers/actions';

const SelectAudienceContainer = compose(
  servicesProvider,
  connect(
    state => ({
      audience: state.engagement.customerGroups,
      selected: getSelectedAudienceKeys(state),
      sendEmailChecked: state.engagement.campaign.sendEmail,
      sendSmsChecked: state.engagement.campaign.sendSms,
      sendPushChecked: state.engagement.campaign.sendPush,
      newCustomerWeeks: getNewCustomerWeeks(state),
      serviceCustomerGroupServiceId: getServiceCustomerGroupServiceId(state),
      campaignType: state.engagement.campaign.type,
    }),
    {
      setCustomerGroup,
      unsetCustomerGroup,
      toggleCustomerGroup,
      setNewCustomerWeeks,
      setServiceCustomerGroupServiceId,
    }
  ),
  withActionByRole(
    'fetchCustomerGroups',
    fetchShopCustomerGroups,
    fetchBarberCustomerGroups,
    fetchBrandCustomerGroups
  ),
  withHandlers({
    fetchCustomerGroups: props => () => {
      const params = {};
      if (props.sendEmailChecked) params.sendEmail = true;
      if (props.sendSmsChecked) params.sendSms = true;
      if (props.sendPushChecked) params.sendPush = true;
      params.newCustomerWeeks = props.newCustomerWeeks;
      if (props.serviceCustomerGroupServiceId) params.serviceId = props.serviceCustomerGroupServiceId;
      props.fetchCustomerGroups(params);
    },
    selectAll: props => () => props.setCustomerGroup({ name: AUDIENCE_TYPE.all }),
    selectCustom: props => () => props.unsetCustomerGroup(),
    toggleAudience: props => group => () => {
      if (props.campaignType === CAMPAIGN_TYPE.recurring) props.unsetCustomerGroup();

      props.toggleCustomerGroup(pick(group, ['name', 'barberId', 'shopId']), props.newCustomerWeeks);

      if (!props.selected.includes(AUDIENCE_TYPE.service) && group.name === AUDIENCE_TYPE.service) {
        const serviceId = group.serviceId || get(props.services, '[0].id') || '';
        props.setServiceCustomerGroupServiceId(serviceId);
      }

      if (group.name === AUDIENCE_TYPE.prospective && !props.selected.includes(AUDIENCE_TYPE.prospective)) {
        FullstoryService.track('Prospective clients audience segment selected');
      }
    },
    changeNewCustomerWeeks: props => e => props.setNewCustomerWeeks(parseInt(e.target.value, 10)),
    changeServiceCustomerGroupServiceId: props => e => props.setServiceCustomerGroupServiceId(e.target.value),
  }),
  withPropsOnChange(
    ['sendEmailChecked', 'sendSmsChecked', 'sendPushChecked', 'newCustomerWeeks', 'serviceCustomerGroupServiceId'],
    (props) => {
      props.fetchCustomerGroups();
    }
  ),
)(SelectAudience);

export default SelectAudienceContainer;
